import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/kishPortInfo`;


const ApikishPortInfo = {

    getAllkishPortInfo: () => {
        const url = `${baseServiceUrl}/getAllkishPortInfo`;
        return ServiceApi.get(url);
    },


};

export default ApikishPortInfo;